import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons/faInfoCircle';
import { FormattedMessage } from 'react-intl';

import { messages } from './messages';
import style from './style.module.less';

export const StoreUpdatingInfoMessage = () => {
  return (
    <div className={style['info-message']}>
      <FontAwesomeIcon className={style['info-icon']} icon={faInfoCircle} />
      <FormattedMessage {...messages.importInfoMessage} />
    </div>
  );
};
